<template>
  <div class="survey-table-detail">
    <el-button @click="$router.back()" size="small">返回</el-button>
    <div class="table" v-if="surveyTableDetail">
      <div v-if="surveyTableData.createBy == user.teacherName" class="invitation" @click="invitationClick"><i class="el-icon-share icon"></i>邀请填写</div>
      <div class="title">
        {{ surveyTableDetail.formName }}
      </div>
      <div class="end-time">结束时间：{{ surveyTableData.endTime }}</div>
      <div class="description" v-html="surveyTableData.description"></div>
      <el-divider></el-divider>
      <div class="completion-status" v-if="completionList.length">
        <div class="status-text">
          填表完成情况&nbsp;&nbsp;<span>({{
            completionList[0].completedResponsesCount +
            "/" +
            (completionList[0].completedResponsesCount +
              completionList[0].pendingResponsesCount)
          }})</span>
        </div>
        <!-- <div class="learn-more" @click="learnMoreClick">查看更多 >></div> -->
        <div class="learn-more" @click="resendSurvey" v-if="surveyTableData.createBy == user.teacherName">通知未填写学生</div>
      </div>
      <el-progress v-if="completionList.length" style="margin: 10px 0" :percentage="(completionList[0].completedResponsesCount /
        (completionList[0].completedResponsesCount +
          completionList[0].pendingResponsesCount)) *
        100
        " :show-text="false"></el-progress>
      <div class="student-list">
        <div class="student-item" :class="item.completionStatus == '1' ? 'completed' : ''"
          v-for="(item, index) in completionList" :key="index" @click="studentClick(item)">
          {{ item.studentName }}
        </div>
      </div>
      <pagination :pageSize="pageInfo.pageSize" :total="total" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"></pagination>
      <el-divider></el-divider>
      <el-form>
        <el-form-item v-for="(item, index) in surveyTableDetail.surveyQuestionsList" :key="index"
          :label="index + 1 + '.' + item.title" :label-position="labelPosition"
          :required="item.isRequired == '1' ? true : false" style="text-align: left">
          <div style="color: #909399;">{{ item.description }}</div>
          <el-radio-group v-model="val" v-if="item.problemType == '1'" :disabled="disabled">
            <el-radio v-for="(rItem, rIndex) in item.surveyOptionsList" :key="rIndex"
              :label="rItem.optionContent"></el-radio>
          </el-radio-group>
          <el-checkbox-group v-model="val" v-if="item.problemType == '2'" :disabled="disabled">
            <el-checkbox v-for="(eItem, eIndex) in item.surveyOptionsList" :key="eIndex" :label="eItem.optionContent"
              :name="eItem.optionContent"></el-checkbox>
          </el-checkbox-group>
          <el-select v-model="val" placeholder="请选择活动区域" v-if="item.problemType == '3'" :disabled="disabled">
            <el-option v-for="(oItem, oIndex) in item.surveyOptionsList" :key="oIndex" :label="oItem.optionContent"
              :value="oItem.optionContent"></el-option>
          </el-select>
          <el-input v-if="item.problemType == '4'" v-model="val" :disabled="disabled"></el-input>
          <el-upload v-if="item.problemType == '5'" action="#" list-type="picture-card" :disabled="disabled">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-empty v-else description="详情内容为空"></el-empty>
    <el-dialog :title="'学生' + studentSurveyResponse.studentName + '填表详情'" :visible.sync="studentSurveyResponseShow"
      width="800px">
      <studentResponseDetails :studentSurveyResponse="studentSurveyResponse" />
    </el-dialog>

    <el-dialog title="邀请填写" :visible.sync="qrCodeDialogVisible" width="400px">
      <div class="qrCode">
        <img :src="qrCodeSrc" alt="二维码" v-if="qrCodeSrc" />
      </div>
    </el-dialog>

    <!-- <completionStatusDialog v-show="dialogTableVisible" :dialogTableVisible.sync="dialogTableVisible"
      :completionList="completionList" :surveyTableData="surveyTableData" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange" :total="total" :pageSize="pageInfo.pageSize" :pageNum="pageInfo.pageNum" /> -->
  </div>
</template>

<script>
import completionStatusDialog from "./components/completion-status-dialog/completionStatusDialog.vue";
import studentResponseDetails from "./components/student-response-details/studentResponseDetails.vue"
export default {
  components: {
    completionStatusDialog,
    studentResponseDetails
  },
  data() {
    return {
      id: "", // 调查表ID
      surveyTableData: null, // 上个页面传来的调查表数据
      surveyTableDetail: null, // 调查表详情数据
      val: "",
      labelPosition: "top",
      disabled: true,
      completionList: [], // 填写完成情况
      dialogTableVisible: false,
      pageInfo: {
        pageSize: 50,
        pageNum: 1,
      },
      total: 0,
      studentSurveyResponse: {},
      studentSurveyResponseShow: false,
      qrCodeSrc: "", // 邀请填写-二维码链接
      qrCodeDialogVisible: false, // 邀请填写-二维码弹窗
    };
  },
  created() {
    this.surveyTableData = JSON.parse(this.$route.query.surveyTableData);
    // console.log("上个页面传来的调查表数据:", this.surveyTableData);
    this.selectQuestionnaireFormDetail();
    this.getCompletionList();
  },
  methods: {
    invitationClick() {
      this.get(this.$url.generateQrCode + `?url=https://www.zlo.com.cn/questionnaireDetail?id=${this.surveyTableData.id}&endTime=${this.surveyTableData.endTime}`).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.qrCodeSrc = res.msg;
        this.qrCodeDialogVisible = true;
      })
    },
    // 学生填写点击
    studentClick(item) {
      if (item.completionStatus != "1") return this.$message.warning("该学生未填写");
      this.get(
        this.$url.selectStudentSurveyResponse +
        "/" +
        this.surveyTableData.id +
        "/" +
        item.studentId
      ).then((res) => {
        // console.log("获取学生填写详情==：", res);

        if (res.code !== 200) return this.$message.error(res.msg);

        this.studentSurveyResponse = Object.assign({}, item, res.data[0]);
        this.studentSurveyResponseShow = true;
        // console.log(this.studentSurveyResponse);

      });
    },
    // 消息再次推送
    resendSurvey() {
      this.get(this.$url.resendSurveyData + "/" + this.surveyTableData.id).then(res => {
        if (res.code == 200) {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      })
    },
    learnMoreClick() {
      this.dialogTableVisible = true;
    },
    selectQuestionnaireFormDetail() {
      this.get(
        this.$url.selectQuestionnaireFormDetail + "/" + this.surveyTableData.id
      ).then((res) => {
        // console.log("获取调查表详情==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.surveyTableDetail = res.data[0];
      });
    },
    getCompletionList() {
      let data = {
        id: this.surveyTableData.id,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.get(
        this.$url.selectSurveyFormsStatistical, data
      ).then((res) => {
        // console.log("获取调查表学生填写情况==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.completionList = res.rows;
        this.total = res.total;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getCompletionList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getCompletionList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./surveyTableDetail.scss";
</style>